import {Variant, Size, ComposableButtonConfig} from "../types";
import {calculateLetterSpacing} from "./helpers";

const athletaComposableButtonConfig = (): ComposableButtonConfig => ({
  defaults: {
    size: Size.xl,
    variant: Variant.solid,
  },
  small: {
    [Variant.border]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "54px",
        letterSpacing: calculateLetterSpacing(120, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "50px",
        letterSpacing: calculateLetterSpacing(120, 16),
        lineHeight: 21 / 16,
        padding: ["12.5px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(120, 14),
        lineHeight: 18 / 14,
        padding: ["13px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.chevron]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 21 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(75, 14),
        lineHeight: 18 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.flat]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 23 / 18,
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 18),
        lineHeight: 21 / 16,
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 18 / 14,
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 14),
        lineHeight: 16 / 12,
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 10),
        lineHeight: 13 / 10,
      },
    },
    [Variant.outline]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "54px",
        letterSpacing: calculateLetterSpacing(120, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "50px",
        letterSpacing: calculateLetterSpacing(120, 16),
        lineHeight: 21 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(120, 14),
        lineHeight: 18 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.solid]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "54px",
        letterSpacing: calculateLetterSpacing(120, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "50px",
        letterSpacing: calculateLetterSpacing(120, 16),
        lineHeight: 21 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(120, 14),
        lineHeight: 18 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.underline]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 18),
        lineHeight: 30 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 28 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 14),
        lineHeight: 26 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 12),
        lineHeight: 24 / 12,
        padding: ["13px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(75, 10),
        lineHeight: 22 / 10,
        padding: ["8.5px", "14px"],
      },
    },
  },
  "x-large": {
    [Variant.border]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "54px",
        letterSpacing: calculateLetterSpacing(120, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "50px",
        letterSpacing: calculateLetterSpacing(120, 16),
        lineHeight: 21 / 16,
        padding: ["12.5px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(120, 14),
        lineHeight: 18 / 14,
        padding: ["13px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "34px",
        letterSpacing: calculateLetterSpacing(120, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.chevron]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 21 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 14),
        lineHeight: 18 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.flat]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 23 / 18,
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 18),
        lineHeight: 21 / 16,
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 18 / 14,
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 14),
        lineHeight: 16 / 12,
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 10),
        lineHeight: 13 / 10,
      },
    },
    [Variant.outline]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "54px",
        letterSpacing: calculateLetterSpacing(120, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "50px",
        letterSpacing: calculateLetterSpacing(120, 16),
        lineHeight: 21 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(120, 14),
        lineHeight: 18 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "34px",
        letterSpacing: calculateLetterSpacing(120, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.solid]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        minHeight: "54px",
        letterSpacing: calculateLetterSpacing(120, 18),
        lineHeight: 23 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        minHeight: "50px",
        letterSpacing: calculateLetterSpacing(120, 16),
        lineHeight: 21 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        minHeight: "48px",
        letterSpacing: calculateLetterSpacing(120, 14),
        lineHeight: 18 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        minHeight: "44px",
        letterSpacing: calculateLetterSpacing(120, 12),
        lineHeight: 16 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        minHeight: "34px",
        letterSpacing: calculateLetterSpacing(120, 10),
        lineHeight: 13 / 10,
        padding: ["8.5px", "14px"],
      },
    },
    [Variant.underline]: {
      [Size.xl]: {
        fontSize: "18px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 18),
        lineHeight: 30 / 18,
        padding: ["13.5px", "14px"],
      },
      [Size.large]: {
        fontSize: "16px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 16),
        lineHeight: 28 / 16,
        padding: ["14px", "14px"],
      },
      [Size.medium]: {
        fontSize: "14px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 14),
        lineHeight: 26 / 14,
        padding: ["14px", "14px"],
      },
      [Size.small]: {
        fontSize: "12px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 12),
        lineHeight: 24 / 12,
        padding: ["12px", "14px"],
      },
      [Size.xs]: {
        fontSize: "10px",
        fontWeight: "demiBold",
        letterSpacing: calculateLetterSpacing(75, 10),
        lineHeight: 22 / 10,
        padding: ["8.5px", "14px"],
      },
    },
  },
});

export default athletaComposableButtonConfig;
